<template>
  <div class="index">
      <headMatter/>
      <div class="banner">
        <div class="banner-left">
          <div class="title">提供信息技术解决方案</div>
          <div class="desc">信息系统与产品的研发、运维、方案定制AI技术应用</div>
          <div class="btn-box">
            <div class="btn">
              看案例
            </div>
            <div class="btn">
              谈合作
            </div>
          </div>
        </div>
        <div class="banner-right">
          <img src="../../assets/eco.png" >
        </div>
      </div>

      <div class="part1">
        <div class="part1-title">我们能为您提供哪些技术方案？</div>
        <div class="part1-desc">What can we do？</div>
        <typeOne :technicalCcheme="technicalCcheme" />
      </div>

      <typeTwo :part2="part2"/>

      <div class="part3">
        <div class="part3-title">AI应用</div>
        <typeThree :part3="part3"/>
      </div>

      <div class="part4">
        <div class="part4-title">主要合作伙伴</div>
        <div class="part4-desc">合作方式：项目外包、技术投资入股等</div>
        <div class="part4-box">
          <div class="box-item" v-for="(item,index) in part4" :key="index">
            <!-- <img src="../../assets/bg.jpg" > -->
            <img :src="require(`../../assets/${item.imgSrc}`)" >
             <span>{{item.desc||''}}</span>
          </div>
        </div>
      </div>

      <footerCom/>
  </div>
</template>

<script>
  import headMatter from '../../components/headMatter.vue'
  import typeOne from '../../components/typeOne.vue'
  import typeTwo from '../../components/typeTwo.vue'
  import typeThree from '../../components/typeThree.vue'
  import footerCom from '../../components/footerMatter.vue'

  export default {
    name:'index',
    components:{
      headMatter,
      typeOne,
      typeTwo,
      typeThree,
      footerCom
    },
    data(){
      return{
        technicalCcheme:[
          {
            title:'商业综合体',
            desc:'以数据驱动新零售，实现购物中心的智慧化运营，大幅提升零售效率帮助商场建立核心数据资产，形成自有数据体系，建立用户画像，精准营销，持续提高营收;基于数据资产，提供相应的工具深度分析客流，提升运营效率',
            imgBox:[
              {
                imgSrc:'taikoo.png',
                desc:'太古汇AI CRM业务中台'
              },
              {
                imgSrc:'k11.jpg',
                desc:'K11商场运营中心系统'
              }
            ]
          },

          {
            title:'智能寻车屏广告系统',
            desc:'解决了访客停车难、寻车难，区域指引不明确，车场容易迷路的问题并对车辆进出场缴费进行管理，同时在各电梯间内布设广告屏，进行广告运营投放，增加停车场的运营收入。',
            imgBox:[
              {
                imgSrc:'che.png',
                desc:'广汽Acura RDX'
              },
              {
                imgSrc:'che2.png',
                desc:'K11艺术购物中心'
              }
            ]
          }
        ],
        part2:[
          {
            title:'新媒体会员管理系统',
            desc:'我们提供基于微信社会化销售工具，帮助企业建立社交化的销售体系',
            btnText:'案例详情',
            imgBox:[
              {
                imgSrc:'qiyeweixin1.jpeg',
                width:'100%'
              },
              {
                imgSrc:'part2.png'
              }
            ]
          },
          {
            title:'赛宝质云知识服务平台',
            desc:'赛宝质云，质量检测优化知识应用服务，为客户提供技术服务与培训的宣传交流平台',
            btnText:'案例详情',
            imgBox:[
              {
                imgSrc:'pic1.png'
              }
            ]
          },
          {
            title:'课后教育综合体系统',
            desc:'以移动互联网技术链接家长、学校、教育主管部门和第三方机构的教育服务平台。为K12阶段学生的课后托管、用餐、学生综合素质课程等服务提供线上线下整体解决方案。平台借助互联网优势，整合社会优质教育服务资源，为孩子健康快乐成长在校园里提供课后全方位服务体系。',
            btnText:'案例详情',
            imgBox:[
              {
                imgSrc:'pic2.png'
              }
            ]
          },
          {
            title:'幼儿园管理系统',
            desc:'提供从招生、报名、分班到日常课程管理的系统化支持',
            btnText:'案例详情',
            imgBox:[
              {
                imgSrc:'pic3.png'
              }
            ]
          },
          {
            title:'医疗健康',
            desc:'系统提供了对在家体检的整体方案支持，包括 销售、产品使用、实验室对接，设备连接、报告推送、医生诊断等',
            btnText:'案例详情',
            imgBox:[
              {
                imgSrc:'pic4.png'
              }
            ]
          }
        ],

        part3:[
          {
            title:'集装箱校验小程序',
            desc:'拍摄集装箱编号，核对校验码',
            btnText:'案例详情',
            imgSrc:'cage.png'
          },
          {
            title:'手机端IVD识别',
            desc:'手机端APP利用摄像头拍摄检测卡图像实时分析视频画面，判定阴阳性',
            btnText:'案例详情',
            imgSrc:'medica.png'
          },
          {
            title:'OCR小票识别系统',
            desc:'扫描电子小票，自动会员积分',
            btnText:'案例详情',
            imgSrc:'code.png'
          }
        ],

        part4:[
          {
            imgSrc:'logo1.png',
            desc:'太古汇地产'
          },
          {
            imgSrc:'logo2.png',
            desc:'K11艺术购物中心'
          },
          {
            imgSrc:'logo3.png',
            desc:'动量网络科技'
          },
          {
            imgSrc:'logo4.png',
            desc:'工信部电子五所'
          },
          {
            imgSrc:'logo5.png',
            desc:'深云教育'
          },
          {
            imgSrc:'logo6.png',
            desc:'合雅木业'
          },
          {
            imgSrc:'logo7.png',
            desc:'东耀教育集团'
          },
          {
            imgSrc:'logo8.png',
            desc:'易捷筛'
          }
        ],
      }
    }
  }
</script>

<style lang="less">
  @media (max-width: 1024px){
    .banner{
      // background-color: #776FF7;
      background-image: url(../../assets/bg.jpg);
      background-size: 100%;
      padding: 30px 0;
      padding-bottom: 150px;
      display: flex;
      flex-direction: column;
      background-position-y: bottom;
      background-repeat: no-repeat;
      .banner-right{
        width: 243px;
        height: 243px;
        margin: 0 auto;
        margin-top: 10px;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .title{
        font-size: 24px;
        color: #fff;
        text-align: center;
        font-weight: bold;
      }
      .desc{
        font-size: 16px;
        color: #fff;
        text-align: center;
        font-weight: bold;
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
      }
      .btn-box{
        display: flex;
        justify-content: center;
        align-items: center;
        .btn{
          margin-top: 30px;
          width: 94px;
          height: 33px;
          border: 1px solid #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 14px;
          line-height: 14px;
          border-radius: 6px;
          &:first-child{
            margin-right: 10px;
          }
          &:last-child{
            margin-left: 10px;
          }
        }
      }
    }
    .part1{
      padding: 30px 0;
      padding-bottom: unset;
      .part1-title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
      }
      .part1-desc{
        font-size: 14px;
        font-weight: bold;
        color: #7F7F7F;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 10px;
      }
    }
    .part3{
      padding-top: 30px;
      .part3-title{
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }

    .part4{
      padding: 30px 0;
      border-bottom: 10px solid #F9F9F9;
      .part4-title{
        font-size: 20px;
        color: #333333;
        text-align:center;
        font-weight: bold;
      }
      .part4-desc{
        font-size: 12px;
        color: #555555;
        text-align: center;
        line-height: 12px;
        margin-top: 20px;
      }
      .part4-box{
        margin-top: 20px;
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 0px));
        grid-column-gap: 0;
        grid-row-gap: 0;
        .box-item{
          height: 64px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border-top: unset;
          &:nth-child(odd){
            border-right: unset;
          }
          // &:nth-child(1){
          //   border-top: 1px solid #898593;
          // }
          // &:nth-child(2){
          //   border-top: 1px solid #898593;
          // }
          img{
            display: block;
            width: 44px;
            height: 44px;
            margin-left: 10px;
          }
          span{
            font-size: 14px;
            color: #555555;
            font-weight: bold;
            margin-left: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue